import { z } from "zod";
import {
	PHOTO_ROULETTE_DEFAULT_NUMBER_OF_PHOTOS,
	PHOTO_ROULETTE_MAX_NUMBER_OF_PHOTOS,
	PHOTO_ROULETTE_MIN_NUMBER_OF_PHOTOS,
} from "./game.js";

export const PHOTO_ROULETTE_PERIOD = {
	WEEK: "week",
	MONTH: "month",
	ALL: "all",
} as const;

export const PHOTO_ROULETTE_PERIOD_VALUES = [PHOTO_ROULETTE_PERIOD.WEEK, PHOTO_ROULETTE_PERIOD.MONTH, PHOTO_ROULETTE_PERIOD.ALL] as const;

export const PHOTO_ROULETTE_DEFAULT_PERIOD: PhotoRoulettePeriod = PHOTO_ROULETTE_PERIOD.ALL;

export const photoRoulettePeriodSchema = z.enum(PHOTO_ROULETTE_PERIOD_VALUES);

export type PhotoRoulettePeriod = z.infer<typeof photoRoulettePeriodSchema>;

export const photoRouletteGameConfigSchema = z.object({
	period: photoRoulettePeriodSchema,
	number_of_photos: z.number().int().min(PHOTO_ROULETTE_MIN_NUMBER_OF_PHOTOS).max(PHOTO_ROULETTE_MAX_NUMBER_OF_PHOTOS),
});

export type PhotoRouletteGameConfig = z.infer<typeof photoRouletteGameConfigSchema>;

export const PHOTO_ROULETTE_DEFAULT_GAME_CONFIG: PhotoRouletteGameConfig = {
	period: PHOTO_ROULETTE_DEFAULT_PERIOD,
	number_of_photos: PHOTO_ROULETTE_DEFAULT_NUMBER_OF_PHOTOS,
};

export const updatePhotoRouletteGameConfigSchema = photoRouletteGameConfigSchema
	.partial()
	.refine((d) => d.period !== undefined || d.number_of_photos !== undefined, {
		message: "empty_update",
	});

export type UpdatePhotoRouletteGameConfigPayload = z.infer<typeof updatePhotoRouletteGameConfigSchema>;
